exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#search-group[data-v-62b5b5e0] {\n\t\t width: -webkit-fill-available;\n}\n#search-input[data-v-62b5b5e0] {\n\t\tpadding-right: 52px;\n\t\tborder-radius: 4px;\n}\n#search-clear[data-v-62b5b5e0] {\n\t\tposition: absolute;\n\t\tright: 32px;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\theight: 16px;\n\t\tmargin: auto;\n\t\tfont-size: 16px;\n\t\tcursor: pointer;\n\t\tcolor: red;\n}\n#search-icon[data-v-62b5b5e0] {\n\t\tposition: absolute;\n\t\tright: 6px;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\theight: 16px;\n\t\tmargin: auto;\n\t\tfont-size: 16px;\n\t\tcursor: pointer;\n\t\tcolor: #9d9d9d;\n}\n", ""]);

// exports
